// Core
import React from "react";

// Instruments
import skillset from "../theme/assets/data/skillset";

// Components
import SectionHeading from "./SectionHeading";
import Skill from "./Skill";

export default class Skillset extends React.Component {
    render () {
        const skills = skillset.map((skill) => {
            return (
                <Skill
                    key = { skill.id }
                    points = { skill.points }
                    title = { skill.title }
                />
            );
        });

        return (
            <section className = 'skillset'>
                <SectionHeading number = '01.' title = 'Набор скилов' />
                {skills}
            </section>
        );
    }
}
